import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { NSEmailService } from './ns-email-service.js';

@customElement('ns-communcation-service')
export class NSCommuncationService extends LitElement {
  private _email?: NSEmailService;

  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;

    this._email = this.querySelector('ns-email-service') || undefined;
    if (!this._email) throw new Error('ns-communcation-service requires ns-email-service as a child');
  }

  email() {
    if (!this._email) throw new Error('missing email service');
    return this._email;
  }

  notify() {
    //
  }

  render() {
    return html`
      <slot></slot>
    `;
  }
}
